<div class="container-fluid" *ngIf="isCheckDataExists">
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_TASK_BY_LEVEL_TAB.TITLE' | translate}}</legend>
        <ng-container *ngFor="let level of listOfLevelsId; trackBy: trackByLevel">
        <div class="custom-table">
            <div class="example-container mat-elevation-z8">
              <table mat-table [dataSource]="listOfTaskTypesObjectOnLevelId[level]" class="custom-table full-width table table-bordered no-border">
                <!-- Define columns -->
                
                <ng-container matColumnDef="taskID">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.TASK_ID' | translate}} </th>
                    <td mat-cell *matCellDef="let element" class="col-sm-1"> {{element.taskID}} </td>
                </ng-container>
                <ng-container matColumnDef="taskDescription">
                    <th mat-header-cell *matHeaderCellDef> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.TASK_DESCRIPTION' | translate}} </th>
                    <td mat-cell  *matCellDef="let element" matTooltip="{{element.taskDescription}}" class="description-width"> {{element.taskDescription}} </td>
                  </ng-container>
                  <ng-container matColumnDef="pmHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.PM' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element">{{element.pmHours | number : '1.2-2'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="engHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.ENG' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.engHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nengHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.NENG' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.nengHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="qengHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.QENG' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.qengHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="cengHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.CENG' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.cengHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="eengHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.EENG' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.eengHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="lengHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.LENG' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.lengHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="specHours" >
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.SPEC' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.specHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="mechHours" >
                    <th mat-header-cell class="col-sm-1" *matHeaderCellDef> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.MECH' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.mechHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="elecHours">
                    <th mat-header-cell *matHeaderCellDef  class="col-sm-1"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.ELEC' | translate}} </th>
                    <td mat-cell class="right-align col-sm-1"  *matCellDef="let element" > {{element.elecHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="servicingOffice" >
                    <th mat-header-cell *matHeaderCellDef class="col-sm-2"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.SERVICING_OFFICE' | translate}} </th>
                    <td mat-cell  *matCellDef="let element" class="center-align col-sm-2"> {{element.servicingOffice }} </td>
                  </ng-container>
                  <ng-container matColumnDef="notes">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-2"> {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.NOTES' | translate}} </th>
                    <td mat-cell  *matCellDef="let element" class="col-sm-2"> {{element.notes }} </td>
                  </ng-container>

                  <ng-container matColumnDef="levelDescription">
                    <th mat-header-cell *matHeaderCellDef class="header-1" [attr.colspan]="displayedColumnsLabor.length"> 
                      {{getLevelName(level)}} 
                    </th>
                  </ng-container>
          
                <!-- Header row -->
                <tr mat-header-row  class="header-row-1" *matHeaderRowDef="['levelDescription']"></tr>
                <tr mat-header-row class="header-row-2" *matHeaderRowDef="displayedColumnsLabor; sticky: true"></tr>
                <!-- Data rows -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsLabor;">
          
                <!-- Row shown when there is no matching data -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell no-data" [attr.colspan]="displayedColumnsLabor.length">{{'COMMON_LABELS.NO_DATA_FOUND' | translate}}</td>
                </tr>
              </table>
            </div>
          </div>
          <br>
        </ng-container>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="!isCheckDataExists">
  {{'REVIEW_SOL_TASK_BY_LEVEL_TAB.TASK_BY_LEVEL_DATA_NOT_FOUND' | translate}}
  </div>